<template>
  <div id="stillTherePopUp" class="cardPopUp">
    <div class="cardBody stillThereCard">
      <h5>Are you still there?</h5>
      <p>There's been no activity for a while.</p>
      <p>To protect your information, we will reset this session shortly if there is no further activity</p>
      <p>Resetting in {{secondsRemaining}} seconds.</p>
      <div class="actions">
        <button @click.prevent.stop="resetSession" class="button is-white">Reset session</button>
        <button @click.prevent.stop="continueSession"  class="button is-danger">I'm here, continue</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      intervalID: null,
      secondsRemaining: 90
    };
  },
  props: ['startTimer'],
  methods: {
    countdown() {
      this.secondsRemaining = 90;

      this.intervalID = window.setInterval(() => {
        this.secondsRemaining -= 1;
        if (this.secondsRemaining == 0) {
          this.resetSession();
          return;
        }
      }, 1000);
    },
    resetSession() {
      clearInterval(this.intervalID);
      this.$router.push('/');
      this.secondsRemaining = 90;
      document.body.classList.remove("stillThere");
      this.$parent.$data.stillThere = false;
    },
    continueSession() {
      document.body.classList.remove("stillThere");
      this.secondsRemaining = 90;
      clearInterval(this.intervalID);
      this.$parent.$data.stillThere = false;
    }
  },
  mounted(){
    this.countdown();
  },
  watch: {
    'startTimer': function(value) {
      if (value) {
        this.countdown()
      }
    }
  }
};
</script>